import { render } from "./settings_users.vue?vue&type=template&id=83cba88a"
import script from "./settings_users.vue?vue&type=script&lang=js"
export * from "./settings_users.vue?vue&type=script&lang=js"
script.render = render

export default script